import { DropdownOption } from "src/createEntityModal/types";
import { formatCurrenciesIntoDropdownOptions } from "src/spread/chartOfAccounts/helpers";
import { Currency } from "./types";

export const reportingCurrencies: Currency[] = [
  { code: "USD", name: "United States Dollar", symbol: "$" },
  { code: "AED", name: "United Arab Emirates Dirham", symbol: "د.إ" },
  { code: "AFN", name: "Afghan Afghani", symbol: "Af" },
  { code: "ALL", name: "Albanian Lek", symbol: "L" },
  { code: "AMD", name: "Armenian Dram", symbol: "Դ" },
  { code: "ANG", name: "NL Antillian Guilder", symbol: "ƒ" },
  { code: "AOA", name: "Angolan Kwanza", symbol: "Kz" },
  { code: "ARS", name: "Argentine Peso", symbol: "$" },
  { code: "AUD", name: "Australian Dollar", symbol: "$" },
  { code: "AWG", name: "Aruban Florin", symbol: "ƒ" },
  { code: "AZN", name: "Azerbaijani Manat", symbol: "ан" },
  {
    code: "BAM",
    name: "Bosnia And Herzegovina Convertible Mark",
    symbol: "КМ"
  },
  { code: "BBD", name: "Barbadian Dollar", symbol: "$" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв" },
  { code: "BHD", name: "Bahraini Dinar", symbol: "s" },
  { code: "BIF", name: "Burundian Franc", symbol: "₣" },
  { code: "BMD", name: "Bermudian Dollar", symbol: "$" },
  { code: "BND", name: "Brunei Dollar", symbol: "$" },
  { code: "BOB", name: "Bolivian Boliviano", symbol: "Bs" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "BSD", name: "Bahamian Dollar", symbol: "$" },
  { code: "BTN", name: "Bhutan Ngultrum", symbol: "Nu" },
  { code: "BWP", name: "Botswana Pula", symbol: "P" },
  { code: "BYN", name: "Belarusian Ruble", symbol: "Br" },
  { code: "BZD", name: "Belize Dollar", symbol: "$" },
  { code: "CAD", name: "Canadian Dollar", symbol: "$" },
  { code: "CDF", name: "Congolese Franc", symbol: "₣" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHf" },
  { code: "CLF", name: "Unidades De Fomento", symbol: "UF" },
  { code: "CLP", name: "Chilean Peso", symbol: "$" },
  { code: "CNH", name: "Chinese Yuan", symbol: "¥" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
  { code: "COP", name: "Colombian Peso", symbol: "$" },
  { code: "CRC", name: "Costa Rican Colon", symbol: "₡" },
  { code: "CUP", name: "Cuban Peso", symbol: "₱" },
  { code: "CVE", name: "Cape Verdean Escudo", symbol: "$" },
  { code: "CYP", name: "Cyprus Pound", symbol: "£CYP" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "DJF", name: "Djiboutian Franc", symbol: "₣" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "DOP", name: "Dominican Peso", symbol: "$" },
  { code: "DZD", name: "Algerian Dinar", symbol: "s" },
  { code: "ECS", name: "Ecuador Sucre", symbol: "S/." },
  { code: "EEK", name: "Estonian Kroon", symbol: "kr" },
  { code: "EGP", name: "Egyptian Pound", symbol: "E£" },
  { code: "ERN", name: "Eritrean Nakfa", symbol: "fk" },
  { code: "ETB", name: "Ethiopian Birr", symbol: "Br" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "FJD", name: "Fijian Dollar", symbol: "$" },
  { code: "FKP", name: "Falkland Islands Pound", symbol: "£" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "GEL", name: "Georgian Lari", symbol: "ლ" },
  { code: "GHC", name: "Ghanaian Cedi", symbol: "₵" },
  { code: "GHS", name: "Ghana Cedi", symbol: "₵" },
  { code: "GIP", name: "Gibraltar Pound", symbol: "£" },
  { code: "GMD", name: "Gambian Dalasi", symbol: "D" },
  { code: "GNF", name: "Guinean Franc", symbol: "₣" },
  { code: "GTQ", name: "Guatemalan Quetzal", symbol: "Q" },
  { code: "GYD", name: "Guyanese Dollar", symbol: "$" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
  { code: "HNL", name: "Honduran Lempira", symbol: "L" },
  { code: "HRK", name: "Croatian Kuna", symbol: "Kn" },
  { code: "HTG", name: "Haitian Gourde", symbol: "G" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
  { code: "ILS", name: "Israeli New Shekel", symbol: "₪" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
  { code: "IQD", name: "Iraqi Dinar", symbol: "د.ع" },
  { code: "IRR", name: "Iranian Rial", symbol: "s" },
  { code: "ISK", name: "Icelandic Krona", symbol: "Kr" },
  { code: "JMD", name: "Jamaican Dollar", symbol: "$" },
  { code: "JOD", name: "Jordanian Dinar", symbol: "s" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
  { code: "KGS", name: "Kyrgyzstani Som", symbol: "лв" },
  { code: "KHR", name: "Cambodian Riel", symbol: "៛" },
  { code: "KMF", name: "Comorian Franc", symbol: "KMF" },
  { code: "KPW", name: "North Korean Won", symbol: "₩" },
  { code: "KRW", name: "South Korean Won", symbol: "₩" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "كك" },
  { code: "KYD", name: "Cayman Islands Dollar", symbol: "$" },
  { code: "KZT", name: "Kazakhstani Tenge", symbol: "〒" },
  { code: "LAK", name: "Lao Kip", symbol: "₭" },
  { code: "LBP", name: "Lebanese Pound", symbol: "s" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs" },
  { code: "LRD", name: "Liberian Dollar", symbol: "$" },
  { code: "LSL", name: "Lesotho Loti", symbol: "L" },
  { code: "LTL", name: "Lithuanian Litas", symbol: "Lt" },
  { code: "LVL", name: "Latvian Lats", symbol: "Ls" },
  { code: "LYD", name: "Libyan Dinar", symbol: "e" },
  { code: "MAD", name: "Moroccan Dirham", symbol: "s" },
  { code: "MDL", name: "Moldovan Leu", symbol: "L" },
  { code: "MGA", name: "Malagasy Ariary", symbol: "MK" },
  { code: "MKD", name: "Macedonian Denar", symbol: "ден" },
  { code: "MMK", name: "Burmese Kyat", symbol: "K" },
  { code: "MNT", name: "Mongolian Togrog", symbol: "₮" },
  { code: "MOP", name: "Macanese Pataca", symbol: "MOP$ " },
  { code: "MRU", name: "Mauritanian Ouguiya", symbol: "UM" },
  { code: "MTL", name: "Maltese Lira", symbol: "Lm" },
  { code: "MUR", name: "Mauritian Rupee", symbol: "₨" },
  { code: "MVR", name: "Maldivian Rufiyaa", symbol: "s" },
  { code: "MWK", name: "Malawian Kwacha", symbol: "MK" },
  { code: "MXN", name: "Mexican Peso", symbol: "$" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "MZN", name: "Mozambican Metical", symbol: "Tn" },
  { code: "NAD", name: "Namibian Dollar", symbol: "$" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦" },
  { code: "NIO", name: "Nicaraguan Cordoba", symbol: "C$" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "NPR", name: "Nepalese Rupee", symbol: "₨" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "$" },
  { code: "OMR", name: "Omani Rial", symbol: "e" },
  { code: "PAB", name: "Panamanian Balboa", symbol: "B/." },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/." },
  { code: "PGK", name: "Papua New Guinean Kina", symbol: "K" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
  { code: "PLN", name: "Polish Złoty", symbol: "zł" },
  { code: "PYG", name: "Paraguayan Guarani", symbol: "₲" },
  { code: "QAR", name: "Qatari Riyal", symbol: "QR" },
  { code: "ROL", name: "Romanian Leu", symbol: "L" },
  { code: "RON", name: "Romanian Lei", symbol: "L" },
  { code: "RSD", name: "Serbian Dinar", symbol: "in" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽" },
  { code: "RUR", name: "Russian Ruble", symbol: "₽" },
  { code: "RWF", name: "Rwandan Franc", symbol: "₣" },
  { code: "SAR", name: "Saudi Riyal", symbol: "SAR" },
  { code: "SBD", name: "Solomon Islands Dollar", symbol: "$" },
  { code: "SCR", name: "Seychellois Rupee", symbol: "₨" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "SGD", name: "Singapore Dollar", symbol: "$" },
  { code: "SHP", name: "Saint Helena Pound", symbol: "£" },
  { code: "SIT", name: "Slovenian Tolar", symbol: "SIT" },
  { code: "SKK", name: "Slovak Koruna", symbol: "Sk" },
  { code: "SLL", name: "Sierra Leonean Leone", symbol: "Le" },
  { code: "SOS", name: "Somali Shilling", symbol: "Sh" },
  { code: "SRD", name: "Surinamese Dollar", symbol: "$" },
  { code: "STN", name: "Sao Tome And Principe Dobra", symbol: "Db" },
  { code: "SVC", name: "El Salvador Colon", symbol: "₡" },
  { code: "SYP", name: "Syrian Pound", symbol: "£S" },
  { code: "SZL", name: "Swazi Lilangeni", symbol: "L" },
  { code: "THB", name: "Thai Baht", symbol: "฿" },
  { code: "TJS", name: "Tajikistan Somoni", symbol: "SM" },
  { code: "TMT", name: "Turkmenistan Manat", symbol: "m" },
  { code: "TND", name: "Tunisian Dinar", symbol: "e" },
  { code: "TOP", name: "Tongan Paʻanga", symbol: "T$" },
  { code: "TRL", name: "Turkish Lira", symbol: "₺" },
  { code: "TRY", name: "New Turkish Lira", symbol: "₺" },
  { code: "TTD", name: "Trinidad And Tobago Dollar", symbol: "$" },
  { code: "TWD", name: "New Taiwan Dollar", symbol: "NT$" },
  { code: "TZS", name: "Tanzanian Shilling", symbol: "Sh" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴" },
  { code: "UGS", name: "Uganda Shilling", symbol: "Sh" },
  { code: "UGX", name: "Ugandan Shilling", symbol: "USh" },
  { code: "UYU", name: "Uruguayan Peso", symbol: "$" },
  { code: "UYU", name: "Peso Uruguayo", symbol: "$U" },
  { code: "UZS", name: "Uzbekistani Soʻm", symbol: "лв" },
  { code: "VEF", name: "Venezuelan Bolivar", symbol: "Bs." },
  { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
  { code: "VUV", name: "Vanuatu Vatu", symbol: "Vt" },
  { code: "WST", name: "Samoan Tala", symbol: "$" },
  { code: "XAF", name: "CFA Franc BEAC", symbol: "CFA" },
  { code: "XBA", name: "European Composite Unit (Eurco)", symbol: "ECU" },
  { code: "XCD", name: "East Caribbean Dollar", symbol: "$" },
  { code: "XOF", name: "C.F.A. Francs B.C.E.A.O.", symbol: "CFA" },
  { code: "XPF", name: "CFP Franc", symbol: "F" },
  { code: "XXX", name: "Transaction Without Currency", symbol: "" },
  { code: "YER", name: "Yemeni Rial", symbol: "﷼" },
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "ZMK", name: "Zambian Kwacha", symbol: "ZK" },
  { code: "ZMW", name: "Zambian Kwacha", symbol: "ZK" },
  { code: "ZWD", name: "Zimbabwe Dollar", symbol: "Z$" }
];

export const reportingCurrencyDropdownOptions = formatCurrenciesIntoDropdownOptions(
  reportingCurrencies
);

export const roundingUnitDropdownOptions: DropdownOption[] = [
  { value: "Actual", label: "Actual" },
  { value: "Thousands", label: "Thousands" },
  { value: "Lakhs", label: "Lakhs" },
  { value: "Millions", label: "Millions" },
  { value: "Crores", label: "Crores" },
  { value: "Billions", label: "Billions" }
];

export const roundingUnitEncapDropdownOptions: DropdownOption[] = [
  { value: "Actual", label: "Actual" },
  { value: "Thousands", label: "Thousands" },
  { value: "Millions", label: "Millions" },
  { value: "Billions", label: "Billions" }
];



// WEBPACK FOOTER //
// ./src/metadata/localOptions.tsx